<template>
  <div class="risk-statement-content">
    <DIV id="page_1">
      <P class="p0 ft0">风险披露声明</P>
      <P
        class="p1 ft1"
      >在使用服务之前，您应该确保了解购买、出售或交易加密货币所涉及的风险。加密货币市场可能会波动， 价格可能会大幅波动，这可能会导致您的数字资产价值突然大幅增加或减少。</P>
      <P class="p2 ft1">您应该仔细评估您的财务状况和风险承受能力是否适合买卖或交易加密货币。您接受并同意您对购买、 出售、交易、持有或处理加密货币的任何决定全权负责。</P>
      <P
        class="p3 ft2"
      >您承认，我方不促成任何交易，也不就在我方平台上进行的贸易或交易提供任何建议。您清楚数字资产交易会带来一定的风险。这些条款、网站或应用程序中的任何信息都不计划构成任何投资决策的基础， 我们也不打算提出任何具体建议。因此，本文件不构成任何证券投资的投资建议或咨询、招标。本风险披露声明不能也无意披露持有、交易数字资产或使用任何服务所涉及的所有潜在风险和其他方面情况。 特别是，您理解这些风险包括但不限于以下内容：</P>
      <P class="p4 ft5 text-bold">
        <SPAN class="ft3">1.</SPAN>
        <SPAN class="ft4">不利市场条件的风险</SPAN>
      </P>
      <P
        class="p5 ft2"
      >数字资产市场仍然是全新的不确定的领域。任何人都不应在其未做好准备承担损失的前提下，进 行数字资产投资或开展数字资产投机活动。数字资产可能无法广泛被企业、个人和其他组织使用， 并且在分布式应用程序创建和开发方面的公众利益十分有限。此种有限的利益会对您的投资带来负面影响。无论是一种或多种数字资产市场的扩大或是缩小，还是一项特定的区块链资产是否会 失去其全部或基本上失去全部价值，这些都是未知的，我们对此不做任何陈述或担保。</P>
      <P class="p4 ft5 text-bold">
        <SPAN class="ft3">2.</SPAN>
        <SPAN class="ft4">市场流动性不足的风险</SPAN>
      </P>
      <P
        class="p6 ft2"
      >数字资产市场的流动性程度各不相同。一些流动性很强，而另一些则流动性不足。流动性不足的 市场会放大其波动性。谁也无法保证会永远存在一个活跃的市场或二级市场用于出售、购买或交 易数字资产或其衍生或附属产品。</P>
      <P class="p7 ft5 text-bold">
        <SPAN class="ft3">3.</SPAN>
        <SPAN class="ft4">法律风险和不利的监管行为风险</SPAN>
      </P>
      <P
        class="p8 ft6"
      >某些数字资产的法律地位可能无法确定。这可能意味着持有或交易数字资产的合法性并不总是明确的。一种或多种数字资产是否以及如何构成财产、资产或任何种类的权利似乎也并不清晰。一 直以来，数字资产都是世界各地监管机构审查的对象。平台的运行和服务的提供可能会受到一个 或多个监管机构的调查或相关行动举措的影响，包括对数字资产等数字令牌的使用、销售或拥有 的许可或限制，这可能将妨碍、限制或终止平台的运营。用户有责任了解和理解如何根据适用法 律使用、监管数字资产以及为数字资产纳税。</P>
    </DIV>
    <DIV id="page_2">
      <P class="p9 ft5 text-bold">
        <SPAN class="ft3">4.</SPAN>
        <SPAN class="ft4">交易对手风险</SPAN>
      </P>
      <P
        class="p10 ft1"
      >将数字资产作为押金或与任何第三方建立托管关系，将使您面临安全违规、合同违约风险和经济 损失风险。对于允许第三方以任何理由持有用户财产的行为，用户应有所警惕。</P>
      <P class="p11 ft5 text-bold">
        <SPAN class="ft3">5.</SPAN>
        <SPAN class="ft4">交易风险</SPAN>
      </P>
      <P
        class="p6 ft2"
      >除了流动性风险之外，任何数字资产市场的价值都是不稳定的，并且可能会发生意外变化。应及 时提醒用户了解自己的头寸和持有量，以及交易和其他市场活动的突然和不利变化将对他们产生 的影响。</P>
      <P class="p7 ft5 text-bold">
        <SPAN class="ft3">6.</SPAN>
        <SPAN class="ft4">与用户凭证相关的风险</SPAN>
      </P>
      <P class="p12 ft7">已获得或了解用户登录凭证或私钥的任何第三方都可以处置该用户的数字资产。</P>
      <P class="p13 ft5 text-bold">
        <SPAN class="ft3">7.</SPAN>
        <SPAN class="ft4">不符合用户期望的风险</SPAN>
      </P>
      <P class="p12 ft15">该平台目前正处于开发之中，或可能会发生重大变化。任何关于平台形式和功能的预期或假设(包括用户行为)在平台上线后可能无法得到满足，原因有多种，包括错误的假设或分析、设计和 实施计划的变更以及执行。</P>
      <P class="p11 ft0 text-bold">
        <SPAN class="ft11 text-bold">8.</SPAN>
        <SPAN class="ft12">盗窃和黑客攻击的风险</SPAN>
      </P>
      <P class="p15 ft15">黑客或其他团体或组织或国家可能试图以多种方式干扰平台或数字资产的可用性，包括服务攻击、 女巫攻击、欺骗、Smurf攻击、恶意软件攻击或基于共识的攻击。</P>
      <P class="p13 ft0 text-bold">
        <SPAN class="ft11">9.</SPAN>
        <SPAN class="ft12">安全薄弱的风险</SPAN>
      </P>
      <P class="p17 ft10">目前存在此类风险，即其他第三方可能会有意或无意地将弱点或漏洞引入平台的核心基础架构元 素中，干扰数字资产的使用或造成数字资产的损失。</P>
      <P class="p11 ft0 text-bold">
        <SPAN class="ft11">10.</SPAN>
        <SPAN class="ft14">加密技术可利用突破的风险</SPAN>
      </P>
      <P class="p10 ft10">密码学的进步或诸如量子计算机的发展等技术进步可能会给加密货币和平台带来风险，从而导致 数字资产被盗或丢失。</P>
      <P class="p11 ft0 text-bold">
        <SPAN class="ft11">11.</SPAN>
        <SPAN class="ft14">未投保所导致的损失风险</SPAN>
      </P>
    </DIV>
    <DIV id="page_3">
      <P class="p18 ft15">
        与银行账户或其他一些金融机构的账户不同，该平台持有的资金或加密货币(包括数字资产)通常未投保。如果发生任何损失，没有公共保险公司或私人保险公司向用户提供追索权。
      </P>
      <P class="p13 ft0 text-bold">
        <SPAN class="ft11">12.</SPAN>
        <SPAN class="ft14">解散或破产的风险</SPAN>
      </P>
      <P class="p12 ft15">有可能由于多种原因，包括平台、业务关系达成失败或竞争性知识产权索赔，我们可能无法继续作为一家企业生存或以其他方式生存，并可能解散或申请清盘或其他破产程序。</P>
      <P class="p19 ft15">
          对于因以下原因而直接或间接导致的任何直接后果性损失或损害，我方明确表示不承担任何责任：
          (i)对这些条款、网站或应用程序中包含的任何信息的依赖，(ii)何此类信息中的任何错误、遗漏或不准确，或(iii)由此导致的任何行动。
      </P>
    </DIV>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.risk-statement-content {
  font: 13px 'Arial';
}

.ft0 {
  line-height: 13px;
}
.ft1 {
  color: #252525;
  line-height: 21px;
}
.ft2 {
  color: #252525;
  line-height: 22px;
}
.ft3 {
  color: #252525;
  line-height: 16px;
}
.ft4 {
  color: #252525;
  margin-left: 27px;
  line-height: 13px;
}
.ft5 {
  color: #252525;
  line-height: 13px;
}
.ft6 {
  color: #252525;
  line-height: 23px;
}
.ft7 {
  color: #252525;
  line-height: 13px;
}
.ft8 {
  line-height: 13px;
}
.ft9 {
  line-height: 24px;
}
.ft10 {
  line-height: 21px;
}
.ft11 {
  line-height: 16px;
}
.ft12 {
  margin-left: 27px;
  line-height: 13px;
}
.ft13 {
  line-height: 16px;
}
.ft14 {
  margin-left: 19px;
  line-height: 13px;
}
.ft15{
    line-height: 20px;
}

.p0 {
  text-align: center;
    font-weight: bold;
}

.p1 {
  text-align: left;
  margin-bottom: 0px;
}
.p2 {
  text-align: justify;
  margin-top: 30px;
  margin-bottom: 0px;
}
.p3 {
  text-align: justify;
  margin-top: 13px;
  margin-bottom: 0px;
}
.p4 {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 0px;
}
.p5 {
  text-align: left;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p6 {
  text-align: justify;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p7 {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 0px;
}
.p8 {
  text-align: justify;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p9 {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 0px;
}
.p10 {
  text-align: left;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p11 {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 0px;
}
.p12 {
  text-align: left;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p13 {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 0px;
}
.p14 {
  text-align: left;
  padding-left: 38px;
  margin-top: 8px;
  margin-bottom: 0px;
}
.p15 {
  text-align: left;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p16 {
  text-align: left;
  padding-left: 38px;
  margin-top: 8px;
  margin-bottom: 0px;
}
.p17 {
  text-align: left;
  padding-left: 37px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p18 {
  text-align: left;
  padding-left: 38px;
  margin-top: 15px;
  margin-bottom: 0px;
}
.p19 {
  text-align: left;
  margin-top: 30px;
  margin-bottom: 0px;
}

.p20 {
  text-align: left;
  margin-top: 32px;
  margin-bottom: 0px;
}
.p21 {
  text-align: left;
  margin-top: 8px;
  margin-bottom: 0px;
}
</style>
